// Fuente única de verdad para el menú lateral y los Accesos Rápidos.
// Cada item: { id, label, Icon (componente), path }.
// El consumidor decide el tamaño del icono al renderizar (className="w-4 h-4" etc).

import {
  PresentationChartLineIcon,
  PencilIcon, EyeIcon, ArrowUpTrayIcon, BuildingStorefrontIcon,
  XCircleIcon, ClipboardDocumentListIcon, SnowflakeIcon, ChartBarIcon,
  ArrowUturnLeftIcon, ArrowPathIcon, CheckCircleIcon, CubeIcon,
  WrenchIcon, ShoppingCartIcon, ArrowsRightLeftIcon, UserIcon,
  BellAlertIcon, BellIcon, MegaphoneIcon, DocumentTextIcon,
  TagIcon, ArrowDownTrayIcon, BellSlashIcon, BanknotesIcon,
  PaintBrushIcon, PlayIcon, ArrowTrendingUpIcon, WrenchScrewdriverIcon,
  CogIcon, PrinterIcon, TargetIcon, TrophyIcon, CalendarIcon,
  SearchIcon, TruckIcon, UsersIcon, MapPinIcon, FolderIcon,
  SunIcon, LockClosedIcon, BuildingOfficeIcon, KeyIcon, LinkIcon,
  GemIcon, ArchiveBoxIcon, PaperAirplaneIcon, SparklesIcon,
  ScaleIcon, BoltIcon, BookOpenIcon, Squares2X2Icon, ExclamationTriangleIcon,
  ClockIcon, LightBulbIcon, CreditCardIcon, DevicePhoneMobileIcon, ReceiptIcon, VideoCameraIcon, BuildingLibraryIcon,
  PencilSquareIcon, ShoppingBagIcon, CalculatorIcon, AcademicCapIcon, FactCheckIcon
} from '../components/ui/Icons';

export const MENU_SECTIONS_COMPLETO = [
  {
    title: 'PEDIDOS',
    items: [
      { id: 'crear-pedido', label: 'Crear Pedido', Icon: PencilIcon, path: '/crear-pedido' },
      { id: 'visualizar-pedidos', label: 'Visualizar Pedidos', Icon: EyeIcon, path: '/visualizar-pedidos' },
      { id: 'visualizar-pedidos-operativo', label: 'Visualizar Pedidos Operativo', Icon: EyeIcon, path: '/visualizar-pedidos-operativo' },
      { id: 'visualizar-pedidos-backoffice', label: 'Visualizar Pedidos BackOffice', Icon: EyeIcon, path: '/visualizar-pedidos-backoffice' },
      { id: 'notificar-envio-clientes', label: 'Notificar Envío Clientes', Icon: ArrowUpTrayIcon, path: '/notificar-envio-clientes' },
      { id: 'pedidos-agencia', label: 'Pedidos Agencia', Icon: BuildingStorefrontIcon, path: '/pedidos-agencia' },
      { id: 'anulados-sac', label: 'Anulados SAC', Icon: XCircleIcon, path: '/anulados-sac' },
      { id: 'solicitudes-anulacion', label: 'Solicitudes Anulación', Icon: ClipboardDocumentListIcon, path: '/solicitudes-anulacion' },
      { id: 'solicitar-pedido-especial', label: 'Solicitar Pedido Especial', Icon: EyeIcon, path: '/solicitar-pedido-especial' },
      { id: 'autorizar-solicitud-pe', label: 'Autorizar Solicitud P.E.', Icon: EyeIcon, path: '/autorizar-solicitud-pe' },
      { id: 'pedidos-congelados', label: 'Pedidos Congelados', Icon: SnowflakeIcon, path: '/pedidos-congelados' },
      { id: 'pedidos-congelados-operativo', label: 'Pedidos Congelados Operativo', Icon: SnowflakeIcon, path: '/pedidos-congelados-operativo' },
      { id: 'reporte-pedidos', label: 'Reporte de Pedidos', Icon: ChartBarIcon, path: '/reporte-pedidos' },
      { id: 'reporte-pedidos-operativo', label: 'Reporte de Pedidos Operativo', Icon: ChartBarIcon, path: '/reporte-pedidos-operativo' },
      { id: 'devoluciones', label: 'Devolución y/o Pérdida', Icon: ArrowUturnLeftIcon, path: '/devoluciones' },
      { id: 'visualizar-devoluciones', label: 'Visualizar Devoluciones', Icon: ArrowUturnLeftIcon, path: '/visualizar-devoluciones' },
      { id: 'movimientos-pedido', label: 'Movimientos Pedido', Icon: ArrowPathIcon, path: '/movimientos-pedido' },
      { id: 'visualizar-aut-pagos-pedidos', label: 'Visualizar Aut. Pagos de Pedidos', Icon: CheckCircleIcon, path: '/visualizar-aut-pagos-pedidos' },
      { id: 'autorizar-pagos-pedidos', label: 'Autorizar Pagos de Pedidos', Icon: CheckCircleIcon, path: '/autorizar-pagos-pedidos' },
      { id: 'cambiar-estado-pedido', label: 'Cambiar Estado de Pedido', Icon: ArrowPathIcon, path: '/cambiar-estado-pedido' },
      { id: 'corregir-guias-pedidos', label: 'Corregir Guías de Pedidos', Icon: CubeIcon, path: '/corregir-guias-pedidos' },
      { id: 'correccion-pedidos', label: 'Corrección de Pedidos', Icon: WrenchIcon, path: '/correccion-pedidos' },
    ]
  },
  {
    title: 'SHOPIFY',
    items: [
      { id: 'pedidos-shopify', label: 'Pedidos Shopify', Icon: ShoppingCartIcon, path: '/pedidos-shopify' },
      { id: 'pagos-tarjeta', label: 'Pagos con Tarjeta', Icon: CreditCardIcon, path: '/pagos-tarjeta' },
      { id: 'auditoria-pedidos-shopify', label: 'Auditoría Pedidos Shopify', Icon: MegaphoneIcon, path: '/auditoria-pedidos-shopify' },
      { id: 'abandonados-borradores', label: 'Borradores / Abandonados', Icon: ArchiveBoxIcon, path: '/abandonados-borradores' },
      { id: 'marketplace-tiktok', label: 'Marketplace y TikTok', Icon: ShoppingBagIcon, path: '/marketplace-tiktok' },
      { id: 'asignacion-tiendas-shopify', label: 'Asignacion Tiendas', Icon: BuildingStorefrontIcon, path: '/asignacion-tiendas-shopify' },
      { id: 'sincronizacion-inventario-shopify', label: 'Sincronizar Inventario', Icon: ArrowsRightLeftIcon, path: '/sincronizacion-inventario-shopify' },
      { id: 'reservas-vs-inventario', label: 'Reservas vs Inventario', Icon: ChartBarIcon, path: '/reservas-vs-inventario' },
      { id: 'formulario-cod', label: 'Formulario COD', Icon: DevicePhoneMobileIcon, path: '/formulario-cod' },
      { id: 'grabaciones-tiendas', label: 'Grabaciones de Tiendas', Icon: VideoCameraIcon, path: '/grabaciones-tiendas' },
      { id: 'personalizador', label: 'Personalizador', Icon: PencilSquareIcon, path: '/personalizador' },
    ]
  },
  {
    title: 'IA',
    items: [
      { id: 'conversaciones-ia', label: 'Conversaciones IA', Icon: PaperAirplaneIcon, path: '/conversaciones-ia' },
      { id: 'revisar-pedidos-ia', label: 'Revisar Pedidos IA', Icon: SparklesIcon, path: '/revisar-pedidos-ia' },
      { id: 'demanda-agotados', label: 'Demanda de Agotados', Icon: BellAlertIcon, path: '/demanda-agotados' },
      { id: 'asignacion-redes-ia', label: 'Asignación de Redes', Icon: LinkIcon, path: '/asignacion-redes-ia' },
      { id: 'configuracion-por-empresa-ia', label: 'Configuración por Empresa', Icon: CogIcon, path: '/configuracion-por-empresa-ia' },
      { id: 'costos-ia', label: 'Costos IA', Icon: BanknotesIcon, path: '/costos-ia' },
      { id: 'descuentos-ia', label: 'Descuentos IA', Icon: ReceiptIcon, path: '/descuentos-ia' },
      { id: 'lumi', label: 'Lumi', Icon: LightBulbIcon, path: '/lumi' },
      { id: 'blacklist-chatbot', label: 'Blacklist Chatbot', Icon: LockClosedIcon, path: '/blacklist-chatbot' },
    ]
  },
  {
    title: 'HERRAMIENTAS',
    items: [
      { id: 'mi-perfil', label: 'Mi Perfil', Icon: UserIcon, path: '/mi-perfil' },
      { id: 'utilidades', label: 'Utilidades', Icon: WrenchScrewdriverIcon, path: '/utilidades' },
      { id: 'mi-asistencia', label: 'Mi Asistencia', Icon: ClockIcon, path: '/mi-asistencia' },
      { id: 'mi-desempeno', label: 'Mi Desempeño', Icon: PresentationChartLineIcon, path: '/mi-desempeno' },
      { id: 'mis-cursos', label: 'Mis Cursos', Icon: AcademicCapIcon, path: '/mis-cursos' },
      { id: 'accesos-rapidos', label: 'Accesos Rápidos', Icon: BoltIcon, path: '/accesos-rapidos' },
      { id: 'tareas', label: 'Tareas', Icon: ClipboardDocumentListIcon, path: '/tareas' },
      { id: 'mis-notas', label: 'Mis Notas', Icon: PencilIcon, path: '/mis-notas' },
      { id: 'alerta-devoluciones', label: 'Alerta Devoluciones', Icon: BellAlertIcon, path: '/alerta-devoluciones' },
      { id: 'ver-pedidos-simple', label: 'Ver Pedidos Simple', Icon: ClipboardDocumentListIcon, path: '/ver-pedidos-simple' },
      { id: 'ver-mis-pedidos-simple', label: 'Ver Mis Pedidos Simple', Icon: UserIcon, path: '/ver-mis-pedidos-simple' },
      { id: 'historial-notificaciones', label: 'Notificaciones', Icon: BellIcon, path: '/historial-notificaciones' },
      { id: 'enviar-notificaciones', label: 'Enviar Notificaciones', Icon: MegaphoneIcon, path: '/enviar-notificaciones' },
      { id: 'solicitudes', label: 'Solicitudes', Icon: DocumentTextIcon, path: '/solicitudes' },
      { id: 'bitacora', label: 'Bitácora', Icon: ExclamationTriangleIcon, path: '/bitacora' },
      { id: 'manual-uso', label: 'Manual de Uso', Icon: BookOpenIcon, path: '/manual-uso' },
    ]
  },
  {
    title: 'BACKOFFICE',
    items: [
      { id: 'colocar-guia', label: 'Colocar # Guía', Icon: TagIcon, path: '/colocar-guia' },
      { id: 'anulados-backoffice', label: 'Anulados BackOffice', Icon: XCircleIcon, path: '/anulados-backoffice' },
      { id: 'solicitudes-anulacion-forza', label: 'Solicitudes Anulación Forza', Icon: ClipboardDocumentListIcon, path: '/solicitudes-anulacion-forza' },
      { id: 'excel-para-forza', label: 'Excel para Forza', Icon: ArrowDownTrayIcon, path: '/excel-para-forza' },
      { id: 'crear-guias-forza-api', label: 'Crear Guías Forza (API)', Icon: BoltIcon, path: '/crear-guias-forza-api' },
      { id: 'guias-manifiestos', label: 'Guías y Manifiestos', Icon: ClipboardDocumentListIcon, path: '/guias-manifiestos' },
      { id: 'excel-entregas-forza', label: 'Excel Entregas Forza', Icon: ChartBarIcon, path: '/excel-entregas-forza' },
      { id: 'liquidaciones-forza', label: 'Liquidaciones Forza', Icon: BanknotesIcon, path: '/liquidaciones-forza' },
      { id: 'cierres-pedidos', label: 'Cierres Pedidos', Icon: BellSlashIcon, path: '/cierres-pedidos' },
    ]
  },
  {
    title: 'MENSAJERIA',
    items: [
      { id: 'visualizar-pedidos-mensajeria', label: 'Visualizar Pedidos Mensajería', Icon: TruckIcon, path: '/visualizar-pedidos-mensajeria' },
      { id: 'notificar-cliente-mensajeria', label: 'Notificar Cliente', Icon: PaperAirplaneIcon, path: '/notificar-cliente-mensajeria' },
      { id: 'reparto-pedidos', label: 'Reparto de Pedidos', Icon: ClipboardDocumentListIcon, path: '/reparto-pedidos' },
      { id: 'traslado-forza', label: 'Trasladar a Forza', Icon: ArrowsRightLeftIcon, path: '/traslado-forza' },
      { id: 'manifiesto-pedidos', label: 'Manifiesto de Pedidos', Icon: DocumentTextIcon, path: '/manifiesto-pedidos' },
      { id: 'guias-capital', label: 'Guías Capital', Icon: TagIcon, path: '/guias-capital' },
      { id: 'anulados-mensajeria', label: 'Anulados Capital', Icon: XCircleIcon, path: '/anulados-mensajeria' },
      { id: 'solicitudes-anulacion-capital', label: 'Solicitudes Anulación Capital', Icon: ClipboardDocumentListIcon, path: '/solicitudes-anulacion-capital' },
      { id: 'cuentas-pedidos', label: 'Cuentas Pedidos', Icon: BanknotesIcon, path: '/cuentas-pedidos' },
      { id: 'autorizar-cuentas-pedidos', label: 'Autorizar Cuentas Pedidos', Icon: CheckCircleIcon, path: '/autorizar-cuentas-pedidos' },
      { id: 'control-pedidos-mensajero', label: 'Control Pedidos por Mensajero', Icon: ChartBarIcon, path: '/control-pedidos-mensajero' },
    ]
  },
  {
    title: 'CREATIVO',
    items: [
      { id: 'crear-proyectos', label: 'Crear Proyectos', Icon: PaintBrushIcon, path: '/crear-proyectos' },
      { id: 'iniciar-proyectos', label: 'Iniciar Proyectos', Icon: PlayIcon, path: '/iniciar-proyectos' },
      { id: 'kpis-creativo', label: 'KPIs Creativo', Icon: ChartBarIcon, path: '/kpis-creativo' },
      { id: 'listados-kpis-artes', label: 'Listados KPIs Artes', Icon: ClipboardDocumentListIcon, path: '/listados-kpis-artes' },
      { id: 'registro-kpis-artes', label: 'Registro KPIs Artes', Icon: PencilIcon, path: '/registro-kpis-artes' },
      { id: 'kpis-artes', label: 'KPIs Artes', Icon: PaintBrushIcon, path: '/kpis-artes' },
    ]
  },
  {
    title: 'PUBLICIDAD',
    items: [
      { id: 'ads-dashboard', label: 'Ads Dashboard', Icon: ArrowTrendingUpIcon, path: '/ads-dashboard' },
      { id: 'ingresos-kpis-sac', label: 'Ingresos KPIs SAC', Icon: ChartBarIcon, path: '/ingresos-kpis-sac' },
      { id: 'mis-kpis-sac', label: 'Mis KPIs SAC', Icon: UserIcon, path: '/mis-kpis-sac' },
      { id: 'registros-kpis-sac', label: 'Registros KPIs SAC', Icon: ClipboardDocumentListIcon, path: '/registros-kpis-sac' },
    ]
  },
  {
    title: 'PRODUCCIÓN',
    items: [
      { id: 'gestion-recetas', label: 'Recetas de Producción', Icon: WrenchScrewdriverIcon, path: '/gestion-recetas' },
      { id: 'registrar-merma', label: 'Ajustes de Productos/Producción', Icon: CogIcon, path: '/registrar-merma' },
      { id: 'control-impresiones', label: 'Control de Impresiones', Icon: PrinterIcon, path: '/control-impresiones' },
      { id: 'pedidos-personalizados', label: 'Pedidos Personalizados', Icon: PaintBrushIcon, path: '/pedidos-personalizados' },
      { id: 'entregas-produccion', label: 'Entregas de Producción', Icon: ArrowsRightLeftIcon, path: '/entregas-produccion' },
      { id: 'tiempos-produccion', label: 'Tiempos de Producción', Icon: ClockIcon, path: '/tiempos-produccion' },
    ]
  },
  {
    title: 'METAS',
    items: [
      { id: 'establecer-metas-sac', label: 'Establecer Metas SAC', Icon: TargetIcon, path: '/establecer-metas-sac' },
      { id: 'consultar-metas-sac', label: 'Consultar Metas SAC', Icon: ArrowTrendingUpIcon, path: '/consultar-metas-sac' },
      { id: 'consultar-mis-metas', label: 'Consultar Mis Metas', Icon: TrophyIcon, path: '/consultar-mis-metas' },
    ]
  },
  {
    title: 'PRODUCTOS',
    items: [
      { id: 'productos', label: 'Productos', Icon: CubeIcon, path: '/productos' },
      { id: 'productos-operativo', label: 'Productos Operativo', Icon: CubeIcon, path: '/productos-operativo' },
      { id: 'complementos-productos', label: 'Complementos de Productos', Icon: LinkIcon, path: '/complementos-productos' },
      { id: 'sets-productos', label: 'Sets de Productos', Icon: ShoppingBagIcon, path: '/sets-productos' },
    ]
  },
  {
    title: 'FINANCIERO',
    items: [
      { id: 'control-financiero-capital', label: 'Control Financiero Capital', Icon: BanknotesIcon, path: '/control-financiero-capital' },
      { id: 'gastos-publicitarios', label: 'Gastos Publicitarios', Icon: ChartBarIcon, path: '/gastos-publicitarios' },
      { id: 'registros-gastos', label: 'Registros de Gastos General', Icon: BanknotesIcon, path: '/registros-gastos' },
      { id: 'facturacion-forza', label: 'Facturación Forza', Icon: ReceiptIcon, path: '/facturacion-forza' },
      { id: 'conciliacion-bancaria', label: 'Conciliación Bancaria', Icon: BuildingLibraryIcon, path: '/conciliacion-bancaria' },
    ]
  },
  {
    title: 'KPIS',
    items: [
      { id: 'kardex2', label: 'Productos/Publi', Icon: ChartBarIcon, path: '/kardex2' },
      { id: 'metas-sac-kpi', label: 'Metas SAC', Icon: TargetIcon, path: '/metas-sac-kpi' },
      { id: 'metas-sac-operativo', label: 'Metas SAC Operativo', Icon: ArrowTrendingUpIcon, path: '/metas-sac-operativo' },
      { id: 'indices-capital', label: 'Índices Capital', Icon: ChartBarIcon, path: '/indices-capital' },
      { id: 'resultados-brutos', label: 'Resultados Brutos', Icon: ChartBarIcon, path: '/resultados-brutos' },
      { id: 'analisis-anual-mensual', label: 'Análisis Anual Mensual', Icon: CalendarIcon, path: '/analisis-anual-mensual' },
      { id: 'proyeccion-diarios', label: 'Proyección - Diarios', Icon: ArrowTrendingUpIcon, path: '/proyeccion-diarios' },
    ]
  },
  {
    title: 'INVENTARIO',
    items: [
      { id: 'consulta-existencias', label: 'Consulta Existencias', Icon: SearchIcon, path: '/consulta-existencias' },
      { id: 'kardex', label: 'Kardex', Icon: ChartBarIcon, path: '/kardex' },
      { id: 'kardex3', label: 'Kardex de Productos - 2.0', Icon: ChartBarIcon, path: '/kardex3' },
      { id: 'auditoria-inventario', label: 'Auditoría de Inventario', Icon: ScaleIcon, path: '/auditoria-inventario' },
      { id: 'alertas-reposicion', label: 'Alertas de Reposición', Icon: BellAlertIcon, path: '/alertas-reposicion' },
      { id: 'productos-3d', label: 'Productos 3D', Icon: CubeIcon, path: '/productos-3d' },
      { id: 'inventario-productos', label: 'Inventario de Productos', Icon: ChartBarIcon, path: '/inventario-productos' },
      { id: 'inventario-productos-detallado', label: 'Inventario de Productos (Detallado)', Icon: ChartBarIcon, path: '/inventario-productos-detallado' },
      { id: 'inventario-productos-operativo', label: 'Inventario de Productos Operativo', Icon: CubeIcon, path: '/inventario-productos-operativo' },
      { id: 'ingreso-productos', label: 'Ingreso de Productos', Icon: ArrowDownTrayIcon, path: '/ingreso-productos' },
      { id: 'ingreso-productos-operativo', label: 'Ingreso de Productos Operativo', Icon: ArrowDownTrayIcon, path: '/ingreso-productos-operativo' },
      { id: 'ingreso-productos-devoluciones', label: 'Ingreso de Productos Devoluciones', Icon: ArrowUturnLeftIcon, path: '/ingreso-productos-devoluciones' },
      { id: 'visualizar-ingresos', label: 'Visualizar Ingresos', Icon: ChartBarIcon, path: '/visualizar-ingresos' },
      { id: 'visualizar-ingresos-basico', label: 'Visualizar Ingresos Básico', Icon: ChartBarIcon, path: '/visualizar-ingresos-basico' },
      { id: 'traslados', label: 'Traslados entre Bodegas', Icon: ArrowsRightLeftIcon, path: '/traslados' },
      { id: 'visualizar-traslados', label: 'Visualizar Traslados', Icon: ClipboardDocumentListIcon, path: '/visualizar-traslados' },
      { id: 'proveedores', label: 'Proveedores', Icon: TruckIcon, path: '/proveedores' },
      { id: 'bodegas', label: 'Bodegas', Icon: BuildingOfficeIcon, path: '/bodegas' },
    ]
  },
  {
    title: 'IMPORTACIONES',
    items: [
      { id: 'ideas-productos-nuevos', label: 'Ideas Productos Nuevos', Icon: LightBulbIcon, path: '/ideas-productos-nuevos' },
      { id: 'seguimiento-importaciones', label: 'Seguimiento de Importaciones', Icon: CubeIcon, path: '/seguimiento-importaciones' },
      { id: 'preparar-importacion', label: 'Preparar Importación', Icon: ClipboardDocumentListIcon, path: '/preparar-importacion' },
      { id: 'pedidos-importacion', label: 'Pedidos de Importación', Icon: ShoppingBagIcon, path: '/pedidos-importacion' },
      { id: 'conteo-importacion', label: 'Contar Cajas', Icon: FactCheckIcon, path: '/conteo-importacion' },
      { id: 'tracking-importaciones', label: 'Tracking de Importaciones', Icon: TruckIcon, path: '/tracking-importaciones' },
      { id: 'costeo-importaciones', label: 'Costeo de Importaciones', Icon: CalculatorIcon, path: '/costeo-importaciones' },
    ]
  },
  {
    title: 'CLIENTES',
    items: [
      { id: 'clientes', label: 'Clientes', Icon: UsersIcon, path: '/clientes' },
      { id: 'reportes-clientes', label: 'Reportes Clientes', Icon: ChartBarIcon, path: '/reportes-clientes' },
      { id: 'departamentos', label: 'Departamentos/Municipios', Icon: MapPinIcon, path: '/departamentos' },
    ]
  },
  {
    title: 'REPORTES',
    items: [
      { id: 'reporte-ubicaciones', label: 'Pedidos por Ubicación', Icon: MapPinIcon, path: '/reporte-ubicaciones' },
      { id: 'reporte-enviados-forza', label: 'Reporte Rezagados Forza', Icon: CubeIcon, path: '/reporte-enviados-forza' },
      { id: 'seguimiento-general-pedidos', label: 'Seguimiento General de Pedidos', Icon: EyeIcon, path: '/seguimiento-general-pedidos' },
      { id: 'notificar-envio-reporte', label: 'Notificar Envío (Reporte)', Icon: ChartBarIcon, path: '/notificar-envio-reporte' },
      { id: 'reporte-ganancias', label: 'Reporte General de Ganancias', Icon: BanknotesIcon, path: '/reporte-ganancias' },
      { id: 'reporte-final-neto', label: 'Reporte Final Ganancias (Neto)', Icon: GemIcon, path: '/reporte-final-neto' },
      { id: 'auditoria-reportes', label: 'Auditoría de Reportes', Icon: ScaleIcon, path: '/auditoria-ganancias' },
      { id: 'analisis-devoluciones', label: 'Análisis de Devoluciones', Icon: ChartBarIcon, path: '/analisis-devoluciones' },
      { id: 'historial-actividad', label: 'Historial de Actividad', Icon: ClockIcon, path: '/historial-actividad' },
    ]
  },
  {
    title: 'RRHH',
    items: [
      { id: 'expedientes', label: 'Expedientes', Icon: FolderIcon, path: '/expedientes' },
      { id: 'vacaciones', label: 'Vacaciones y Permisos', Icon: SunIcon, path: '/vacaciones' },
      { id: 'evaluacion-desempeno', label: 'Evaluación del Desempeño', Icon: ChartBarIcon, path: '/evaluacion-desempeno' },
      { id: 'reconocimientos', label: 'Reconocimientos y Evaluación', Icon: TrophyIcon, path: '/reconocimientos' },
      { id: 'asistencia', label: 'Asistencia', Icon: ClockIcon, path: '/asistencia' },
      { id: 'cursos', label: 'Cursos', Icon: AcademicCapIcon, path: '/cursos' },
    ]
  },
  {
    title: 'ADMINISTRADOR',
    items: [
      { id: 'usuarios', label: 'Usuarios', Icon: UserIcon, path: '/usuarios' },
      { id: 'permisos', label: 'Permisos', Icon: LockClosedIcon, path: '/permisos' },
      { id: 'configurar-departamentos-empresa', label: 'Departamentos de la Empresa', Icon: Squares2X2Icon, path: '/configurar-departamentos-empresa' },
      { id: 'configurar-notificaciones', label: 'Configurar Notificaciones', Icon: BellAlertIcon, path: '/configurar-notificaciones' },
      { id: 'configurar-tareas', label: 'Configurar Tareas', Icon: ClipboardDocumentListIcon, path: '/configurar-tareas' },
      { id: 'empresas', label: 'Crear Empresa', Icon: BuildingOfficeIcon, path: '/empresas' },
      { id: 'logos', label: 'Logos', Icon: PaintBrushIcon, path: '/logos' },
      { id: 'tarifas-costos', label: 'Tarifas de Costos', Icon: BanknotesIcon, path: '/tarifas-costos' },
      { id: 'id-cliente-forza', label: 'ID Cliente Forza', Icon: KeyIcon, path: '/id-cliente-forza' },
      { id: 'link-guias', label: 'Link de Guías', Icon: LinkIcon, path: '/link-guias' },
    ]
  }
];

// Dado un ID de módulo, retorna {id, label, Icon, path, seccion} o null.
export function getModuloInfo(moduloId) {
  for (const seccion of MENU_SECTIONS_COMPLETO) {
    const item = seccion.items.find(i => i.id === moduloId);
    if (item) return { ...item, seccion: seccion.title };
  }
  return null;
}
